<template>
  <div class="pos-r wd-100p ht-100p ov-h">
    <div class="pos-a zindex-99 wd-100p ht-100p ov-h-y">
      <div v-animate="{ name: 'bounceInDown', delay: 0 }">
        <div class="pos-a wd-100p dp-flex jus-c" :class="mob ? 'mg-t-9vh' : 'pd-t-3p'">
          <div><img src="@/assets/logo.png" :class="mob ? 'wd-60' : 'wd-120'" /></div>
          <div class="cr-theme0 mg-l-20" :class="mob ? 'wd-50p' : 'font-30'">
            <div class="fw">{{ txt_1 }}</div>
            <div v-html="mob ? txt_3 : txt_2"></div>
          </div>
        </div>
        <img class="wd-100p" :src="require('@/assets/bg/top_bg_' + (mob ? 'mob' : 'pc') + '.png')" />
      </div>
      <!----------start---------->
      <div class="wd-100p pos-r">
        <div style="margin:20px 2.6% 20px 2.6%;" :class="mob ? 'pd-l-r-10' : 'pd-l-r-30'" class="pd-t-30">
          <Row :gutter="mob ? 10 : 40">
            <Col :sm="48" :xs="12" v-for="(item, i) in shcoolCLassList" :key="i">
            <div class="pd-b-50 pointer" v-animate="{ name: 'bounceInLeft', delay: 100 * i }" @click="clickItem(i)">
              <div class="ov-h bx-hui br-rs-30">
                <div class="lht-0 ">
                  <img class="wd-100p" :src="require('@/assets/home/' + item.img)" />
                  <div class="wd-100p ht-12" :class="'bg-l-' + i"></div>
                </div>
                <div class="cr-theme0 bg-white">
                  <h1 class="pd-l-r-20 ht-100 txt-ali-c pd-t-b-20">{{ item.name }}</h1>
                  <!-- <div class="pd-l-r-20 ht-130 pd-b-30">{{ item.dsc }}</div> -->
                </div>
              </div>
            </div>
            </Col>

          </Row>
        </div>
      </div>
      <!----------end---------->
    </div>
    <div class="wd-100p ht-100p lht-0" v-animate="{ name: 'bounceInUp', delay: 0 }">
      <img class="wd-100p ht-100p" :src="require('@/assets/bg/bg_' + (mob ? 'mob' : 'pc') + '.jpg')" />
    </div>
  </div>
</template>

<script>
// import Header from "@/components/header.vue";
import config from "@/config";

export default {
  components: {
    // Header
  },
  data() {
    return {
      showVirtual: false,
      shcoolCLassList: [],
      txt_1: "Every Fuhua Gem - Learner, Leader & Innovator",
      txt_2: "●Creating Opportunities ●Leading Learning  ●Building Communities",
      txt_3: "●Creating Opportunities<br/> ●Leading Learning<br/>  ●Building Communities",
    };
  },
  methods: {
    clickref(ref) {
      this.pushr(ref);
    },
    clickItem(index) {
      if(index==0){
        this.clickref("Virtual?page=" + index + "&link=0");
        return;
      }
      this.clickref("Class?page=" + index);
    },
  },
  created() {
    // 切换页面时滚动条自动滚动到顶部
    this.shcoolCLassList = config.shcoolCLassList;
  },
  mounted() {
    // 切换页面时滚动条自动滚动到顶部
    window.scrollTo(0, 0);
    this.$store.dispatch("getMob");
  },
  computed: {
    mob() {
      return this.$store.state.mob;
    },
    virtualLink() {
      return this.$store.state.virtualLink;
    },
  },
  watch: {
    virtualLink(val) {
      this.showVirtual = false;
    },
  },
  beforeDestroy() {
  },
};
</script>

